var sliders = document.querySelectorAll(".sliders-container");
    sliders.forEach((slider, index) => {
        let single_slide = slider.querySelectorAll(".single_slide");
        let dotsContainer = slider.querySelector(".slides_pagination");
        let dots = [];
        let delayTime = index === 0 ? 3000 : index === 1 ? 4000 : 4500; // Set delay time based on index

        for (let i = 0; i < single_slide.length; i++) {
            let dot = document.createElement("span");
            dot.classList.add("dot");
            dot.addEventListener("click", function () {
                showSlide(i);
            });
            dotsContainer.appendChild(dot);
            dots.push(dot);
        }

        let currentIndex = 0;

        function showSlide(n) {
            currentIndex = n;
            for (let i = 0; i < single_slide.length; i++) {
                single_slide[i].style.display = "none";
                dots[i].classList.remove("active");
            }

            single_slide[n].style.display = "block";
            dots[n].classList.add("active");
        }

        function changeSlide() {
            currentIndex = (currentIndex + 1) % single_slide.length;
            showSlide(currentIndex);
            setTimeout(changeSlide, delayTime);
        }

        changeSlide();
    });